module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "ys-dialog-container",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    staticClass: "ys-dialog-dismiss",
    attrs: {
      "row": "",
      "wrap": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "ys-dialog ys-album-dialog",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-2": ""
    }
  }, [_c('div', {
    staticClass: "album-cover",
    style: ({
      'background-image': 'url(' + _vm.album.cover.url + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "album-info mt-3"
  }, [_c('v-flex', {
    attrs: {
      "x12": "",
      "mb-3": "",
      "py-2": "",
      "border-top": "",
      "border-bottom": ""
    }
  }, [_c('h4', [_vm._v("Album Stats")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "album-stats"
  }, [_c('div', [_c('label', [_vm._v("Uploaded:")]), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.album.created_at)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Plays:")]), _c('span', [_vm._v(_vm._s(_vm._f("formatNumberWithComma")(_vm.album.played)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Reposts:")]), _c('span', [_vm._v(_vm._s(_vm._f("formatNumberWithComma")(_vm.album.reposted)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Downloads:")]), _c('span', [_vm._v(_vm._s(_vm._f("formatNumberWithComma")(_vm.album.donwloaded)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Album only for live video:")]), _vm._v(" "), (_vm.album.is_only_for_live_stream) ? _c('span', {
    staticClass: "red--text"
  }, [_c('b', [_vm._v("Yes")])]) : _c('span', [_vm._v("No")])])]), _vm._v(" "), (_vm.album_product) ? _c('v-flex', {
    attrs: {
      "x12": "",
      "mt-4": "",
      "mb-3": "",
      "py-2": "",
      "border-top": "",
      "border-bottom": ""
    }
  }, [_c('h4', [_vm._v("Product Attachment")])]) : _vm._e(), _vm._v(" "), (_vm.album_product) ? _c('v-flex', [_c('v-card', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-card-media', {
    attrs: {
      "src": _vm.album_product.covers[0].cover.thumb.url,
      "contain": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.album_product.name))]), _vm._v(" "), _c('div', {
    staticClass: "product-price"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.album_product.price)))])])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x12": "",
      "mt-3": "",
      "mb-3": "",
      "py-2": "",
      "border-top": "",
      "border-bottom": ""
    }
  }, [_c('h4', [_vm._v("Contributors")])]), _vm._v(" "), _c('v-list', {
    attrs: {
      "subheader": "",
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-avatar', {
    staticClass: "mr-2"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.avatar.url
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.user.username)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Uploader")])], 1)], 1), _vm._v(" "), _vm._l((_vm.album.contributors), function(c, index) {
    return (_vm.album.contributors && _vm.album.contributors.length > 0) ? _c('v-list-tile', {
      key: ("contributor-" + index)
    }, [_c('v-list-tile-avatar', {
      staticClass: "mr-2"
    }, [_c('img', {
      attrs: {
        "src": c.user.avatar.url
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(c.user.username)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(c.user_role)
      }
    })], 1)], 1) : _vm._e()
  })], 2), _vm._v(" "), (_vm.album.collaborators && _vm.album.collaborators.length > 0) ? _c('v-flex', {
    attrs: {
      "x12": "",
      "mt-3": "",
      "mb-3": "",
      "py-2": "",
      "border-top": "",
      "border-bottom": ""
    }
  }, [_c('h4', [_vm._v("Collaborators")])]) : _vm._e(), _vm._v(" "), _c('v-list', _vm._l((_vm.album.collaborators), function(c, index) {
    return (_vm.album.collaborators && _vm.album.collaborators.length > 0) ? _c('v-list-tile', {
      key: ("collaborator-" + index)
    }, [_c('v-list-tile-avatar', {
      staticClass: "mr-2"
    }, [_c('img', {
      attrs: {
        "src": c.user.avatar.url
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(c.user.username)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(c.user_role)
      }
    })], 1)], 1) : _vm._e()
  }))], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "pl-2": "",
      "border-left": ""
    }
  }, [_c('div', {
    staticClass: "album-action"
  }, [_c('label', {
    staticClass: "album-name"
  }, [_vm._v(_vm._s(_vm.album.name))]), _vm._v(" "), _c('v-menu', {
    staticClass: "more-menu",
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    staticClass: "more-btn",
    attrs: {
      "slot": "activator",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    key: "delete_album",
    staticClass: "default-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.deleteAlbum()
      }
    }
  }, [_c('v-list-tile-title', [_c('label', [_vm._v("Delete Entire Album")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-wrapper"
  }, [_c('table', {
    staticClass: "tracks-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-xs-left"
  }, [_vm._v("Track Title")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_vm._v("Sampled from Yousound")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_vm._v("Played")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tracks), function(track) {
    return _c('tr', [_c('td', {
      staticClass: "text-xs-left"
    }, [_vm._v(_vm._s(track.name))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [(_vm.isSampledTrack(track.id)) ? _c('span', {
      staticClass: "album_credit-btn",
      on: {
        "click": function($event) {
          _vm.show_album_credit_dialog = true
        }
      }
    }, [_vm._v("Yes")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(track.played))]), _vm._v(" "), _c('td', [_c('v-btn', {
      staticClass: "remove-btn",
      attrs: {
        "dark": "",
        "small": "",
        "color": "red"
      },
      nativeOn: {
        "click": function($event) {
          _vm.deleteTrack(track.id)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }))])])])], 1), _vm._v(" "), _c('v-dialog', {
    staticClass: "album-credits-dialog",
    attrs: {
      "scrollable": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.show_album_credit_dialog),
      callback: function($$v) {
        _vm.show_album_credit_dialog = $$v
      },
      expression: "show_album_credit_dialog"
    }
  }, [(_vm.show_album_credit_dialog) ? _c('v-card', {
    staticClass: "album-dialog-body"
  }, [_c('v-card-title', [_vm._v("Album Credits")]), _vm._v(" "), _c('v-btn', {
    staticClass: "dialog-close-btn",
    nativeOn: {
      "click": function($event) {
        _vm.show_album_credit_dialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("highlight_off")])], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "height": "300px"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Album Name: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._v(_vm._s(_vm.album.name))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Release Date: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.album.released_at)))])]), _vm._v(" "), (_vm.album.location && _vm.album.location != '') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Location: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._v(_vm._s(_vm.album.location))])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Genre: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._v(_vm._s(_vm.genres))])]), _vm._v(" "), (_vm.album.collaborators && _vm.album.collaborators.length > 0) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Collaborators: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._l((_vm.album.collaborators), function(c) {
    return [_c('div', {
      staticClass: "collaborator-info"
    }, [_c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (c.user.slug))
      }
    }, [_vm._v(_vm._s(c.user.username))]), _vm._v(" - " + _vm._s(c.user_role))], 1)]
  })], 2)]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Contributors: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_c('div', {
    staticClass: "contributor-info"
  }, [_c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": ("/" + (_vm.album.user.slug))
    }
  }, [_vm._v(_vm._s(_vm.album.user.username))]), _vm._v(" - Uploader")], 1)]), _vm._v(" "), (_vm.album.contributors && _vm.album.contributors.length > 0) ? _c('label', {
    staticClass: "album-info-text"
  }, [_vm._l((_vm.album.contributors), function(c) {
    return [_c('div', {
      staticClass: "contributor-info"
    }, [_c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (c.user.slug))
      }
    }, [_vm._v(_vm._s(c.user.username))]), _vm._v(" - " + _vm._s(c.user_role))], 1)]
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.album.samplings && _vm.album.samplings.length > 0) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Samples: ")]), _vm._v(" "), (_vm.album.samplings && _vm.album.samplings.length > 0) ? _c('label', {
    staticClass: "album-info-text"
  }, [_vm._l((_vm.album.samplings), function(s) {
    return [_c('div', {
      staticClass: "sampling-info"
    }, [_c('label', [_vm._v(_vm._s(s.sampling_track.name))]), _vm._v(": "), _c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (s.sample_user.slug))
      }
    }, [_vm._v(_vm._s(s.sample_user.username))]), _vm._v(" "), _c('span', [_vm._v(" - " + _vm._s(s.sample_track.name))])], 1)]
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.album.labels && _vm.album.labels.length > 0) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Label: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": ("/" + (_vm.album.labels[0].user.slug))
    }
  }, [_vm._v(_vm._s(_vm.album.labels[0].user.username))])], 1)]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "album-info-label"
  }, [_vm._v("About the album: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._v(_vm._s(_vm.album.description))])])], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16c71c98","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/components/album_detail_dialog.vue
// module id = 1624
// module chunks = 180